import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function formatValue(value) {
  if (value >= 1000000) return (value / 1000000).toFixed(1) + 'M';
  if (value >= 1000) return (value / 1000).toFixed(0) + 'K';
  return value;
}

export default function SummaryChart({ type, title, data }) {
  if (!data || !data.length) return null;
  const keys = Object.keys(data[0]).filter(k => k !== 'year');
  return (
    <div style={{ margin: '16px 0', padding: '16px', background: '#fafaf7', borderRadius: '8px', border: '1px solid #e8e8e0' }}>
      <div style={{ fontSize: '13px', fontWeight: 500, color: '#1a1a1a', marginBottom: '12px' }}>{title}</div>
      <ResponsiveContainer width="100%" height={200}>
        {type === 'line' ? (
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0ea" />
            <XAxis dataKey="year" tick={{ fontSize: 11 }} />
            <YAxis tickFormatter={formatValue} tick={{ fontSize: 11 }} />
            <Tooltip formatter={(v) => formatValue(v)} />
            <Legend />
            {keys.map((key, i) => (
              <Line key={key} type="monotone" dataKey={key} stroke={i === 0 ? '#1e3a5f' : '#c9952a'} strokeWidth={2} dot={{ r: 3 }} />
            ))}
          </LineChart>
        ) : (
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0ea" />
            <XAxis dataKey="year" tick={{ fontSize: 11 }} />
            <YAxis tickFormatter={formatValue} tick={{ fontSize: 11 }} />
            <Tooltip formatter={(v) => formatValue(v)} />
            <Legend />
            {keys.map((key, i) => (
              <Bar key={key} dataKey={key} fill={i === 0 ? '#1e3a5f' : '#c9952a'} radius={[3, 3, 0, 0]} />
            ))}
          </BarChart>
        )}
      </ResponsiveContainer>
    </div>
  );
}
